import { useAxios } from "@/app/providers/AxiosProvider";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export default function useDeleteFloat() {
  const api = useAxios();
  const client = useQueryClient();

  const mutation = useMutation({
    mutationFn: (floatId) => {
      return api.delete(`/floats/${floatId}`);
    },
    onSuccess: () => {
      client.invalidateQueries({ queryKey: ["floats"] });
    },
  });

  return mutation.mutate;
}